import Navbar from "../../../ui/blocks/Navbar";
import PageContent from "../../../ui/partials/MainContent";
import React from "react";

import SelfSubscriptionCourses from "../components/SelfSubscriptionCourses";
import BreadCrumbs from "../../../ui/components/BreadCrumbs";

const SelfSubscriptionPage = () => {
  return (
    <main className="flex min-h-full w-full">
      <Navbar />
      <PageContent
        sx={{
          paddingLeft: "24px !important",
          "& >:first-child": {
            paddingLeft: "0px !important",
          },
        }}
      >
        <BreadCrumbs />
        <SelfSubscriptionCourses />
      </PageContent>
    </main>
  );
};

export default SelfSubscriptionPage;
